export default "__VITE_ASSET__Ez03hkPX__"